export default "__VITE_ASSET__B1Gb8IhR__"